import React, { useState } from 'react';
import './LoginForm.css';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import facebookLogo from './assets/Facebook.png';
import humanIcon from './assets/human-icon.png';

export default function LoginForm({ close, openSignup }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const emailPattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;

  const handleLogin = e => {
    e.preventDefault();
    if (!emailPattern.test(email) || !password) {
      return setEmailError("Enter valid Gmail and password.");
    }

    fetch("https://kodez.robokalam.in/api/login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password })
    })
      .then(res => res.json())
      .then(data => {
        console.log("Login response:", data);
        if (data.status === "success") {
          const user = data.user;
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("userRole", user.role);

          close?.();

          const dest = data.redirect ||
            (user.role === "admin" ? "/dashboard/admin" :
              user.role === "mentor" ? "/dashboard/mentor" :
                "/dashboard/student");

          navigate(dest);
        } else {
          alert(data.message);
        }
      })
      .catch(() => alert("Server error. Please try again."));
  };

  const handleBackClick = () => {
    if (close) close();
    else navigate(-1);
  };

  // ✅ Google Login Handler
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });

        const data = await res.json();

        const backendRes = await fetch("https://kodez.robokalam.in/api/google-login.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: data.email }),
        });

        const backendData = await backendRes.json();

        if (backendData.status === "success") {
          localStorage.setItem("user", JSON.stringify(backendData.user));
          localStorage.setItem("userRole", backendData.user.role);
          close?.();

          const role = backendData.user.role;
          if (role === "admin") navigate("/dashboard/admin");
          else if (role === "mentor") navigate("/dashboard/mentor");
          else navigate("/dashboard/student");
        } else {
          alert("User not found. Please sign up first.");
        }
      } catch (error) {
        console.error(error);
        alert("❌ Google login failed. Try again.");
      }
    },
    onError: () => alert("❌ Google Sign-In failed."),
  });

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div className="back-button" onClick={handleBackClick}>
          <span className="arrow">←</span> Back
        </div>

        <div className="profile-icon">
          <img src={humanIcon} alt="user" className="profile-icon-img" />
        </div>

        <form onSubmit={handleLogin}>
          <div className="d-flex flex-column input-group">
            <label>Email</label>
            <div className={`input-icon ${emailError ? 'input-error' : ''}`}>
              <i className="fa fa-envelope" />
              <input
                type="email"
                placeholder="Email ID"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onBlur={() => setEmailError(emailPattern.test(email) ? '' : 'Please enter a valid Gmail address')}
                required
              />
            </div>
            {emailError && <p className="error-text">{emailError}</p>}
          </div>

          <div className="d-flex flex-column input-group password-wrapper">
            <label>Password</label>
            <div className="input-icon">
              <i className="fa fa-key" />
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <span className="toggle-password" onClick={() => setShowPassword(prev => !prev)}>
                <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </span>
            </div>
          </div>

          <div className="options">
            <label className="remember">
              <input type="checkbox" /> Remember me
            </label>
            <a href="/forgot-password">Forgot password</a>
          </div>

          <button type="submit" className="login-btn">LOGIN</button>

          <div className="separator">or</div>

          {/* ✅ Updated Google Login Button */}
          <div className="custom-google-btn" onClick={() => googleLogin()} style={{
            cursor: 'pointer',
            padding: '12px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google" style={{ width: 20, marginRight: 10 }} />
            Login with Google
          </div>

          <button
            type="button"
            className="social-btn"
            onClick={() => alert("Facebook signup coming soon.")}
          >
            <img src={facebookLogo} alt="Facebook" /> Login with Facebook
          </button>

          <p className="bottom-text">
            Don’t have an account?{' '}
            <span onClick={openSignup} className="signup-link">Sign up</span>
            <br />
            By continuing you agree to our&nbsp;
            <a href="https://learn.robokalam.com/termsofuse" target="_blank" rel="noreferrer">Terms of Service</a> and&nbsp;
            <a href="https://learn.robokalam.com/privacypolicy" target="_blank" rel="noreferrer">Privacy Policy</a>
          </p>

          <p className="support-text">
            Need help? <a href="mailto:team@robokalam.com">team@robokalam.com</a>
          </p>
        </form>
      </div>
    </div>
  );
}
